import { useEffect, useState } from "react";
import api, { fmtUsd, fmtPct } from "../lib/api";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { Input } from "./ui/input";

const FILTERS = [
  { key: "all", label: "Все" },
  { key: "crypto", label: "Крипто" },
  { key: "stock", label: "xStocks" },
];

export default function PairsList({ active, onSelect }) {
  const [pairs, setPairs] = useState([]);
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/market/symbols").then((r) => alive && setPairs(r.data)).catch(() => {});
    load();
    const i = setInterval(load, 1500);
    return () => { alive = false; clearInterval(i); };
  }, []);

  const filtered = pairs.filter((p) => {
    if (filter !== "all" && p.category !== filter) return false;
    return p.symbol.toLowerCase().includes(query.toLowerCase());
  });

  return (
    <div className="h-full flex flex-col bg-[#111827] border-r border-[#1F2937]" data-testid="pairs-list">
      <div className="px-3 pt-3 pb-2 border-b border-[#1F2937]">
        <div className="relative mb-2">
          <MagnifyingGlass size={14} className="absolute left-2 top-1/2 -translate-y-1/2 text-[#9CA3AF]" />
          <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search"
            className="h-8 pl-7 text-xs bg-[#0A0E17] border-[#1F2937] rounded-sm" data-testid="pairs-search" />
        </div>
        <div className="flex gap-1">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              data-testid={`pairs-filter-${f.key}`}
              className={`px-2.5 py-1 rounded-full text-[11px] font-medium transition-colors ${filter === f.key ? "bg-white/[0.08] text-[#E3B341] ring-1 ring-inset ring-white/[0.12]" : "text-[#6B7280] hover:text-white hover:bg-white/[0.05]"}`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-[1fr_auto_auto] gap-x-2 px-3 py-1.5 overline text-[10px] border-b border-[#1F2937]">
        <span>Pair</span>
        <span className="text-right">Price</span>
        <span className="text-right">24h%</span>
      </div>
      <div className="flex-1 overflow-y-auto">
        {filtered.map((p) => (
          <button
            key={p.symbol}
            onClick={() => onSelect(p.symbol)}
            className={`w-full grid grid-cols-[1fr_auto_auto] gap-x-2 px-3 py-2 text-xs hover:bg-[#1F2937] transition-colors ${active === p.symbol ? "bg-[#1F2937] border-l-2 border-[#FCD535]" : "border-l-2 border-transparent"}`}
            data-testid={`pair-row-${p.symbol}`}
          >
            <span className="text-left font-medium flex items-center gap-1.5">
              {p.symbol.replace("USDT", "/USDT")}
              {p.category === "stock" && !p.market_open && (
                <span className="w-1.5 h-1.5 rounded-full bg-[#F6465D] shrink-0" title="Рынок закрыт" data-testid={`market-closed-${p.symbol}`} />
              )}
            </span>
            <span className="mono text-right">{fmtUsd(p.price, p.price < 1 ? 4 : 2)}</span>
            <span className={`mono text-right ${p.change_pct >= 0 ? "text-[#0ECB81]" : "text-[#F6465D]"}`}>
              {fmtPct(p.change_pct)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
